import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchRepatriationsTransactionsObject from '../../api/RepatriationsTransactionsObjectAPI';
import { REPATRIATIONS_TRANSACTIONS_OBJECT_REQUEST } from '../actions/types/RepatriationsTransactionsObjectActionsTypes';
import { postRepatriationsTransactionsObjectSuccessActionCreator, postRepatriationsTransactionsObjectFailureActionCreator } from '../actions/RepatriationsTransactionsObjectActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doRepatriationsTransactionsObjectWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchRepatriationsTransactionsObject, action.payload);
    yield put(postRepatriationsTransactionsObjectSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.repatriations.transaction.object.success'),
    }));
  } catch (error) {
    yield put(postRepatriationsTransactionsObjectFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doRepatriationsTransactionsObjectWatcher() {
  yield takeLatest(REPATRIATIONS_TRANSACTIONS_OBJECT_REQUEST, doRepatriationsTransactionsObjectWorker);
}

export default doRepatriationsTransactionsObjectWatcher;
